import { createTheme } from '@mui/material/styles';
import { orangePalette, greenPalette, blackPalette, sandPalette } from './colors';

const headingFont = "'Fraunces', 'Georgia', serif";
const bodyFont = "'Raleway', sans-serif";

const heading = {
  fontFamily: headingFont,
  color: blackPalette[500],
  fontWeight: 600,
  letterSpacing: '-0.01em',
  lineHeight: 1.15,
};

const theme = createTheme({
  shape: {
    borderRadius: 16,
  },
  palette: {
    primary: {
      main: orangePalette[500],
      light: orangePalette[300],
      dark: orangePalette[700],
      contrastText: '#fff',
    },
    secondary: {
      main: greenPalette[500],
      light: greenPalette[300],
      dark: greenPalette[700],
    },
    neutral: {
      main: blackPalette[500],
      light: blackPalette[300],
      dark: blackPalette[700],
    },
    sand: {
      main: sandPalette[100],
      light: sandPalette[50],
      dark: sandPalette[300],
    },
    background: {
      default: sandPalette[100],
      paper: '#ffffff',
    },
    text: {
      primary: blackPalette[500],
      secondary: blackPalette[400],
    },
  },
  typography: {
    fontFamily: bodyFont,
    h1: { ...heading, fontWeight: 700, fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' },
    h2: { ...heading, fontWeight: 700, fontSize: 'clamp(2.1rem, 4.5vw, 3.5rem)' },
    h3: { ...heading, fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)' },
    h4: { ...heading, fontSize: 'clamp(1.5rem, 2.5vw, 2rem)' },
    h5: { ...heading, fontSize: 'clamp(1.3rem, 2vw, 1.6rem)' },
    h6: { ...heading, fontSize: '1.2rem' },
    subtitle1: {
      fontFamily: bodyFont,
      fontWeight: 500,
    },
    // Texto chico en mayúsculas para encabezar secciones
    overline: {
      fontFamily: bodyFont,
      fontWeight: 600,
      fontSize: '0.75rem',
      letterSpacing: '0.2em',
      lineHeight: 2,
    },
    body1: {
      fontFamily: bodyFont,
      color: blackPalette[500],
      fontWeight: 400,
      lineHeight: 1.75,
    },
    body2: {
      fontFamily: bodyFont,
      color: blackPalette[500],
      fontWeight: 400,
      lineHeight: 1.7,
    },
    button: {
      fontFamily: bodyFont,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '10px 24px',
          transition: 'background-color .25s ease, transform .25s ease, box-shadow .25s ease',
        },
        contained: {
          '&:hover': {
            backgroundColor: orangePalette[600],
            transform: 'translateY(-1px)',
            boxShadow: '0 8px 20px rgba(203, 110, 40, 0.3)',
          },
        },
        outlined: {
          borderColor: orangePalette[500],
          borderWidth: 1.5,
          '&:hover': {
            backgroundColor: orangePalette[50],
            borderColor: orangePalette[500],
            borderWidth: 1.5,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
        elevation: {
          boxShadow: '0 10px 30px -12px rgba(35, 31, 32, 0.15)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: '0 10px 30px -12px rgba(35, 31, 32, 0.15)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
